import { effect, signal } from "omi";

const layoutContainerRef = signal<HTMLElement | null>(null);

export function useLayoutContainer() {
  const register = (ref: HTMLElement) => {
    if (layoutContainerRef.value == null) {
      layoutContainerRef.value = ref;
    }
  };

  const onRegister = (func: (ref: HTMLElement) => void) => {
    effect(() => {
      if (layoutContainerRef.value) {
        func(layoutContainerRef.value);
      }
    });
  };

  const unregister = () => {
    if (layoutContainerRef.value != null) {
      layoutContainerRef.value = null;
    }
  };

  return { ref: layoutContainerRef, onRegister, unregister, register };
}
